import moment from 'moment';

const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
const TIME_REGEX = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]?([ ]? [a|p]m)?$/;
const DATE_REGEX = /^([0]?[1-9]|1[0-2]|\d{4})[-|/](0[1-9]|1[0-9]|2[0-9]|3[0-1])[-|/](\d{4}|[0]?[1-9]|1[1-2])$/;
const SLUG_REGEX = /^[a-z0-9]+[a-z0-9-_]*[a-z0-9]+$/;
const ZIP_REGEX = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
const PHONE_REGEX = /(^(?:\([2-9]\d{2}\) ?|[2-9]\d{2}(?:-?| ?))[2-9]\d{2}[- ]?\d{4}$)/;
const URL_REGEX = /(^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$)/;

export const REQUIRED = (value) => {
  if (typeof value === 'string') {
    return value && value.trim() ? undefined : 'Required';
  }
  return value ? undefined : 'Required';
};

export const COLOR = value => /^#([A-Fa-f0-9]{3}$)|([A-Fa-f0-9]{6}$)/.test(value);

export const EMAIL = value => (value && !EMAIL_REGEX.test(value) ? 'Invalid email address' : undefined);

export const TIME = value => (value && !TIME_REGEX.test(value) ? 'Invalid time' : undefined);

export const DATE = (value) => {
  if (typeof value === 'object') {
    return undefined;
  }
  return value && !DATE_REGEX.test(value) ? 'Invalid date' : undefined;
};

export const ZIP = value => (value && !ZIP_REGEX.test(value) ? 'Invalid zip code' : undefined);

export const PHONE = value => (value && !PHONE_REGEX.test(value) ? 'Invalid phone number' : undefined);

const maxLength = max => value => (value && value.length > max ? `Must be ${max} characters or less` : undefined);

export const NUMBER = (value) => {
  const number = Number(value);
  const isNumber = Number.isInteger(number);
  if (value && !isNumber) {
    return 'Invalid number';
  }
  return undefined;
};

export const MAX_LENGTH_15 = maxLength(15);
export const MAX_LENGTH_20 = maxLength(20);
export const MAX_LENGTH_25 = maxLength(25);
export const MAX_LENGTH_30 = maxLength(30);
export const MAX_LENGTH_35 = maxLength(35);
export const MAX_LENGTH_50 = maxLength(50);
export const MAX_LENGTH_40 = maxLength(40);
export const MAX_LENGTH_60 = maxLength(60);
export const MAX_LENGTH_80 = maxLength(80);
export const MAX_LENGTH_100 = maxLength(100);
export const MAX_LENGTH_150 = maxLength(150);
export const MAX_LENGTH_200 = maxLength(200);
export const MAX_LENGTH_250 = maxLength(250);
export const MAX_LENGTH_400 = maxLength(400);
export const MAX_LENGTH_800 = maxLength(800);
export const MAX_LENGTH_1000 = maxLength(1000);
export const MAX_LENGTH_2000 = maxLength(2000);
export const MAX_LENGTH_5000 = maxLength(5000);

export const fakeValid = () => (undefined);

export const PASSWORD = value => (value && value.length < 8 ? 'Password must be at least 8 characters long.' : undefined);

export const NOT_ZOLA = value => (value && (value.replace('zola', '') !== value) ? 'Your Zola registry not showing up? Call us at 408-657-9652 to add it.' : undefined);

export const SLUG = value => ((value && !SLUG_REGEX.test(value)) ? 'Please use only lowercase letters, numbers, underscores and hyphens. Cannot start or end with a hyphen or underscore.' : undefined);

export const VALIDATE_URL = urlValue => ((urlValue && URL_REGEX.test(urlValue)));

export const CHECK_CURRENT_WEDDING_DATE = (value, input) => {
  const currentlySelectedDate = moment(input.currentlySelectedDate);
  const { registryIsPublic } = input;
  const date = moment();
  const weddingDateHasPassed = currentlySelectedDate.isBefore(date, 'day');
  if (registryIsPublic && weddingDateHasPassed) {
    return 'Your wedding date has passed and cannot be changed';
  }
  return undefined;
};

export const DATE_WITHIN_VALID_RANGE = (value) => {
  if (typeof value === 'object') {
    if (value.isBefore('2012')) {
      return 'Date cannot be before 2012';
    } if (value.isAfter(moment().add(10, 'y'), 'year')) {
      return `Date cannot be after ${moment().add(10, 'y').format('YYYY')}`;
    }
    return undefined;
  }
  const date = moment.utc(value, 'MM/DD/YYYY');
  if (date.isBefore('2012')) {
    return 'Date cannot be before 2012';
  } if (date.isAfter(moment().add(10, 'y'), 'year')) {
    return `Date cannot be after ${moment().add(10, 'y').format('YYYY')}`;
  }
  return undefined;
};

export const DATE_AFTER_NOW = (value) => {
  const date = moment.utc(value, 'MM/DD/YYYY');
  const now = moment().format('MM/DD/YYYY');
  if (date.isBefore(now)) {
    return 'Hmm… this looks like a past date.';
  }
  if (date.isAfter(moment().add(10, 'y'), 'year')) {
    return `Date cannot be after ${moment()
      .add(10, 'y')
      .format('YYYY')}`;
  }
  return undefined;
};



// WEBPACK FOOTER //
// ./src/components/common/form/commonValidations.js